import { render } from "./Tickets.vue?vue&type=template&id=08554589&scoped=true"
import script from "./Tickets.vue?vue&type=script&lang=js"
export * from "./Tickets.vue?vue&type=script&lang=js"

import "./Tickets.vue?vue&type=style&index=0&id=08554589&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/front/intranet-gpaie/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08554589"]])

export default __exports__